import './_product-recommendations.scss';
import component from './product-recommendations';

export default component;
